export default __webpack_public_path__ + "static/media/b-3.d2ec2191.svg";